import { render } from "./TopVotes.vue?vue&type=template&id=3008b832&scoped=true"
import script from "./TopVotes.vue?vue&type=script&lang=js"
export * from "./TopVotes.vue?vue&type=script&lang=js"

import "./TopVotes.vue?vue&type=style&index=0&id=3008b832&lang=scss"
import "./TopVotes.vue?vue&type=style&index=1&id=3008b832&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3008b832"]])

export default __exports__